import { Model, Post, User, Topic } from "@/models";

export default class Like extends Model {
  static type = "likes";
  likeable!: Post|Topic;
  user!: User;
}
